import { get, post } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

export function getScoringGrids(documentId, siteId) {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/scoring`);
}

export function generateScoring(documentId, siteId) {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/scoring`, { documentId, siteId });
}

export function updateScoringKnockoutCriteria(documentId, siteId, documentScoringGridId, knockoutCriteria, fromPartner, partnerId) {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/scoring/${documentScoringGridId}/knockoutcriteria`, {
    documentId,
    siteId,
    documentScoringGridId,
    knockoutCriteria,
    fromPartner,
    partnerId
  });
}

export function updateScoringCategory(documentId, siteId, documentScoringGridId, scoringClassificationId, entityType, scoringCategories) {
  return post(
    `${url}/leasingdocument/${documentId}/${siteId}/scoring/${documentScoringGridId}/classification/${scoringClassificationId}/entityType/${entityType}/category`,
    { documentId, siteId, documentScoringGridId, scoringClassificationId, entityType, scoringCategories }
  );
}

export function updateScoringFinancialIndicators(
  documentId,
  siteId,
  documentScoringGridId,
  entityType,
  engineScoringId,
  scoringClassificationId,
  indicatorList,
  periodDimensions
) {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/scoring/${documentScoringGridId}/financialindicators`, {
    documentId,
    siteId,
    documentScoringGridId,
    entityType,
    engineScoringId,
    scoringClassificationId,
    indicatorList,
    periodDimensions
  });
}

export function updateFinancialIndicatorDimensions(
  documentId,
  siteId,
  documentScoringGridId,
  entityType,
  scoringClassificationId,
  financialIndicators,
  periodDimensions,
  engineScoringId
) {
  return post(`${url}/leasingdocument/${documentId}/${siteId}/scoring/${documentScoringGridId}/financialindicatorDimensions`, {
    documentId,
    siteId,
    documentScoringGridId,
    entityType,
    scoringClassificationId,
    financialIndicators,
    periodDimensions,
    engineScoringId
  });
}

export function getDocumentScoringResult(documentId, siteId) {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/scoringresult`);
}

export function updateScoringFileWithAccountStatementData(
  documentId,
  siteId,
  scoringGridType,
) {
  return post(`${url}/leasingdocument/scoring/update-scoring-file-with-account-statement-data`, {
    documentId,
    siteId,
    scoringGridType
  },
  { documentId, siteId, scoringGridType});
}